
/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  ComplianceResponse,
  MandatoryDocumentForm,
  ValidationError,
} from '../models';
import {
    ComplianceResponseFromJSON,
    ComplianceResponseToJSON,
    MandatoryDocumentFormFromJSON,
    MandatoryDocumentFormToJSON,
    ValidationErrorFromJSON,
    ValidationErrorToJSON,
} from '../models';

export interface AddMandatoryDocumentRequest {
    typeId: string;
    mandatoryDocumentForm: MandatoryDocumentForm;
}

export interface ComplianceOfCompanyTypeRequest {
    typeId: string;
}

export interface RefreshComplianceForCompanyTypeRequest {
    typeId: string;
}

export interface RemoveMandatoryDocRequest {
    typeId: string;
    complianceFileId: string;
}

export interface UpdateMandatoryDocumentRequest {
    typeId: string;
    complianceFileId: string;
    mandatoryDocumentForm: MandatoryDocumentForm;
}

/**
 * 
 */
export class ComplianceAdminApi extends runtime.BaseAPI {

    /**
     * add a mandatory document for compliance of a given company type
          */
    async addMandatoryDocumentRaw(requestParameters: AddMandatoryDocumentRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['typeId'] == null) {
            throw new runtime.RequiredError(
                'typeId',
                'Required parameter "typeId" was null or undefined when calling addMandatoryDocument().'
            );
        }

        if (requestParameters['mandatoryDocumentForm'] == null) {
            throw new runtime.RequiredError(
                'mandatoryDocumentForm',
                'Required parameter "mandatoryDocumentForm" was null or undefined when calling addMandatoryDocument().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/compliance/api/admin/company/type/{typeId}/compliance`.replace(`{${"typeId"}}`, encodeURIComponent(String(requestParameters['typeId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MandatoryDocumentFormToJSON(requestParameters['mandatoryDocumentForm']),
        }, initOverrides);

        return response;
    }

    /**
     * add a mandatory document for compliance of a given company type
          */
    async addMandatoryDocument(requestParameters: AddMandatoryDocumentRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.addMandatoryDocumentRaw(requestParameters, initOverrides);
    }

    /**
     * list of mandatory documents for compliance of a given company type
          */
    async complianceOfCompanyTypeRaw(requestParameters: ComplianceOfCompanyTypeRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ComplianceResponse>> {
        if (requestParameters['typeId'] == null) {
            throw new runtime.RequiredError(
                'typeId',
                'Required parameter "typeId" was null or undefined when calling complianceOfCompanyType().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ComplianceResponse>({
            path: `/compliance/api/admin/company/type/{typeId}/compliance`.replace(`{${"typeId"}}`, encodeURIComponent(String(requestParameters['typeId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ComplianceResponseFromJSON(response._data); }
        return response;
    }

    /**
     * list of mandatory documents for compliance of a given company type
          */
    async complianceOfCompanyType(requestParameters: ComplianceOfCompanyTypeRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ComplianceResponse> {
        const response = await this.complianceOfCompanyTypeRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Trigger a compliance recompute for all freelancers of a given company type.  **IMPORTANT**: This endpoint is not accessible through the UI for security reasons and is especially useful when the legal documents required for the company type change.  Fires one compliance refresh command per freelancer company of the given type. 
          */
    async refreshComplianceForCompanyTypeRaw(requestParameters: RefreshComplianceForCompanyTypeRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['typeId'] == null) {
            throw new runtime.RequiredError(
                'typeId',
                'Required parameter "typeId" was null or undefined when calling refreshComplianceForCompanyType().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/compliance/api/admin/company/type/{typeId}/refresh-compliance`.replace(`{${"typeId"}}`, encodeURIComponent(String(requestParameters['typeId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Trigger a compliance recompute for all freelancers of a given company type.  **IMPORTANT**: This endpoint is not accessible through the UI for security reasons and is especially useful when the legal documents required for the company type change.  Fires one compliance refresh command per freelancer company of the given type. 
          */
    async refreshComplianceForCompanyType(requestParameters: RefreshComplianceForCompanyTypeRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.refreshComplianceForCompanyTypeRaw(requestParameters, initOverrides);
    }

    /**
     * delete a mandatory document for compliance of a given company type
          */
    async removeMandatoryDocRaw(requestParameters: RemoveMandatoryDocRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['typeId'] == null) {
            throw new runtime.RequiredError(
                'typeId',
                'Required parameter "typeId" was null or undefined when calling removeMandatoryDoc().'
            );
        }

        if (requestParameters['complianceFileId'] == null) {
            throw new runtime.RequiredError(
                'complianceFileId',
                'Required parameter "complianceFileId" was null or undefined when calling removeMandatoryDoc().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/compliance/api/admin/company/type/{typeId}/compliance/{complianceFileId}`.replace(`{${"typeId"}}`, encodeURIComponent(String(requestParameters['typeId']))).replace(`{${"complianceFileId"}}`, encodeURIComponent(String(requestParameters['complianceFileId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * delete a mandatory document for compliance of a given company type
          */
    async removeMandatoryDoc(requestParameters: RemoveMandatoryDocRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.removeMandatoryDocRaw(requestParameters, initOverrides);
    }

    /**
     * update a mandatory document for compliance of a given company type
          */
    async updateMandatoryDocumentRaw(requestParameters: UpdateMandatoryDocumentRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['typeId'] == null) {
            throw new runtime.RequiredError(
                'typeId',
                'Required parameter "typeId" was null or undefined when calling updateMandatoryDocument().'
            );
        }

        if (requestParameters['complianceFileId'] == null) {
            throw new runtime.RequiredError(
                'complianceFileId',
                'Required parameter "complianceFileId" was null or undefined when calling updateMandatoryDocument().'
            );
        }

        if (requestParameters['mandatoryDocumentForm'] == null) {
            throw new runtime.RequiredError(
                'mandatoryDocumentForm',
                'Required parameter "mandatoryDocumentForm" was null or undefined when calling updateMandatoryDocument().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/compliance/api/admin/company/type/{typeId}/compliance/{complianceFileId}`.replace(`{${"typeId"}}`, encodeURIComponent(String(requestParameters['typeId']))).replace(`{${"complianceFileId"}}`, encodeURIComponent(String(requestParameters['complianceFileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MandatoryDocumentFormToJSON(requestParameters['mandatoryDocumentForm']),
        }, initOverrides);

        return response;
    }

    /**
     * update a mandatory document for compliance of a given company type
          */
    async updateMandatoryDocument(requestParameters: UpdateMandatoryDocumentRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.updateMandatoryDocumentRaw(requestParameters, initOverrides);
    }

}
